<template>
    <el-tabs type="border-card" :lazy="true">
        <el-tab-pane label="全部退款">
            <refund :type="1"/>
        </el-tab-pane>
        <el-tab-pane label="待退款">
            <refund :type="2"/>
        </el-tab-pane>
        <el-tab-pane label="已退款">
            <refund :type="3"/>
        </el-tab-pane>
        <el-tab-pane label="退款驳回">
            <refund :type="4"/>
        </el-tab-pane>
    </el-tabs>
</template>

<script>
    import refund from "../../views/order/refund";
    export default {
        components:{refund},
        data(){
            return{

            }
        },
        mounted() {
        },
        methods:{

        }
    }
</script>